import CoreEventDispatcher from '@/core/event/coreEventDispatcher';

const dispatcher = new CoreEventDispatcher();

class EventDispatcher {

    static addEventListener(type, listener) {
        dispatcher.addEventListener(type, listener);
    }

    static hasEventListener(type, listener) {
        return dispatcher.hasEventListener(type, listener);
    }

    static removeEventListener(type, listener) {
        dispatcher.removeEventListener(type, listener);
    }

    static dispatchEvent(event) {
        dispatcher.dispatchEvent(event);
    }

    /**
     * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
     * @param element
     * @param events
     * @param handler
     * @param useCapture
     */
    static addMultipleEventListeners(element, events, handler, useCapture = false) {
        events.split(' ').forEach((value) => element.addEventListener(value, handler, useCapture));
    }

    /**
     * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
     * @param element
     * @param events
     * @param handler
     * @param useCapture
     */
    static removeMultipleEventListeners(element, events, handler, useCapture = false) {
        events.split(' ').forEach((value) => element.removeEventListener(value, handler, useCapture));
    }
}

export default EventDispatcher;
